import React from 'react';
import Card from './Card';

const TONES = {
  info: 'text-bun-blue',
  success: 'text-bun-success-accent',
  warning: 'text-bun-warning',
  danger: 'text-bun-danger-accent',
  neutral: 'text-bun-stone',
};

/** Shared chart chrome; callers supply passive labeled values, never overlay markup. */
export default function ChartTooltip({ title, rows = [], valueFormatter }) {
  return (
    <Card raised>
      <Card.Section className="space-y-2 text-bun-meta">
        <p className="font-semibold">{title}</p>
        {rows.map((row, index) =>
          row.heading ? (
            <p
              key={index}
              className="border-t border-bun-line-soft pt-2 font-semibold text-bun-stone"
            >
              {row.heading}
            </p>
          ) : (
            <p
              key={index}
              className={`flex justify-between gap-5 ${TONES[row.tone] || 'text-bun-text'}`}
            >
              <span>{row.label}</span>
              <span className={row.strong ? 'font-semibold' : 'tabular-nums'}>
                {typeof row.value === 'number' && valueFormatter
                  ? valueFormatter(row.value)
                  : row.value}
              </span>
            </p>
          )
        )}
      </Card.Section>
    </Card>
  );
}
